"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeMiddleware = exports.middlewareDebug = void 0;
const log_1 = require("./log");
exports.middlewareDebug = log_1.jrlDebug.extend('middleware');
function composeMiddleware(componentMiddlewares) {
    const pipeline = (props, middlewareProps, services, ...steps) => {
        const [step, ...next] = steps;
        exports.middlewareDebug('Executing', { name: step.name, props, middlewareProps });
        return step
            ? step(props, middlewareProps, services, (stepProps, stepMiddlewareProps, stepServices) => pipeline(stepProps, stepMiddlewareProps, stepServices, ...next))
            : null;
    };
    return (props, middlewareProps, services, next) => {
        return pipeline(props, middlewareProps, services, ...componentMiddlewares, (cp, mp, s) => {
            return next(cp, mp, s);
        });
    };
}
exports.composeMiddleware = composeMiddleware;
//# sourceMappingURL=middlewares.js.map